import { createSlice } from '@reduxjs/toolkit';

const videoProcessingSlice = createSlice({
  name: 'videoProcessing',
  initialState: {
    jobs: {}, // { jobId: { id, status, progress, result, lessonId, lessonTitle } }
    isLoading: false,
    error: null,
  },
  reducers: {
    addProcessingJob: (state, action) => {
      const { jobId, lessonId, lessonTitle } = action.payload;
      state.jobs[jobId] = {
        id: jobId,
        status: 'queued',
        progress: 0,
        result: null,
        lessonId,
        lessonTitle,
      };
    },
    updateJobStatus: (state, action) => {
      const { jobId, status, progress, result, lessonId } = action.payload;
      if (state.jobs[jobId]) {
        state.jobs[jobId] = {
          ...state.jobs[jobId],
          status: status || state.jobs[jobId].status,
          progress: progress !== undefined ? progress : state.jobs[jobId].progress,
          result: result !== undefined ? result : state.jobs[jobId].result,
          lessonId: lessonId || state.jobs[jobId].lessonId, // Update lessonId if provided
        };
      }
    },
    setJob: (state, action) => {
      const { jobId, jobData } = action.payload;
      state.jobs[jobId] = jobData;
    },
    setAllJobs: (state, action) => {
      const jobs = action.payload;
      // Merge with existing jobs, keeping lessonTitle if it exists
      jobs.forEach((job) => {
        const existingJob = state.jobs[job.id];
        state.jobs[job.id] = {
          ...job,
          lessonTitle: existingJob?.lessonTitle || job.lessonTitle || 'Video Processing',
          lessonId: existingJob?.lessonId || job.lessonId,
        };
      });
    },
    removeJob: (state, action) => {
      const { jobId } = action.payload;
      delete state.jobs[jobId];
    },
    clearAllJobs: (state) => {
      state.jobs = {};
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { addProcessingJob, updateJobStatus, setJob, setAllJobs, removeJob, clearAllJobs, setLoading, setError } = videoProcessingSlice.actions;
export default videoProcessingSlice.reducer;

